var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "k-pager" },
    [
      _c(
        "w-btn-icon",
        {
          attrs: { disabled: _vm.page === 1 },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.gotoPage(1)
            },
          },
        },
        [_c("i-first")],
        1
      ),
      _c(
        "w-btn-icon",
        {
          attrs: { disabled: _vm.page === 1 },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.back.apply(null, arguments)
            },
          },
        },
        [_c("i-back")],
        1
      ),
      _c(
        "transition-group",
        {
          staticClass: "pages",
          attrs: { name: "fade-fast", tag: "div", mode: "out-in" },
        },
        [
          _vm._l(_vm.pagesBefore, function (p) {
            return _c(
              "w-btn",
              {
                key: p,
                staticClass: "pager-page",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.gotoPage(p)
                  },
                },
              },
              [_vm._v(_vm._s(p))]
            )
          }),
          _c(
            "w-btn",
            {
              key: _vm.page,
              staticClass: "pager-page",
              attrs: { disabled: "" },
            },
            [_vm._v(_vm._s(_vm.page))]
          ),
          _vm._l(_vm.pagesAfter, function (p) {
            return _c(
              "w-btn",
              {
                key: p,
                staticClass: "pager-page",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.gotoPage(p)
                  },
                },
              },
              [_vm._v(_vm._s(p))]
            )
          }),
          _vm.showEnd && _vm.lastPage && _vm.lastPage < _vm.pages
            ? [
                _c("div", { key: "ellipsis", staticClass: "pager-page" }, [
                  _vm._v("..."),
                ]),
                _c(
                  "w-btn",
                  {
                    key: "end",
                    staticClass: "end",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.gotoPage(_vm.pages)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.pages))]
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c(
        "w-btn-icon",
        {
          attrs: { disabled: _vm.page === _vm.pages },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.forward.apply(null, arguments)
            },
          },
        },
        [_c("i-forward")],
        1
      ),
      _c(
        "w-btn-icon",
        {
          attrs: { disabled: _vm.page === _vm.pages },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.gotoPage(_vm.pages)
            },
          },
        },
        [_c("i-last")],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }